import { TrackLocation } from "@tvg/ts-types/Race";

export const getFlagLabel = (location?: TrackLocation) => {
  if (location?.country === "USA" && location?.state) return location?.state;
  return location?.country ?? "";
};
